import React from "react";
import { YearParts } from "./YearParts";
import { useTranslate } from "../../helpers";
import { FocusableHeader } from "../../components";

export const HeaderGroup = () => {
  const t = useTranslate();
  return (
    <div className="mct-c-header-group">
      <FocusableHeader
        className="ds-text-heading--3x"
        text={t("landing_page.explore_coverage_options")}
      />
      <YearParts />
    </div>
  );
};
